<div class="role-page">
  @if (!role) {
    <div class="role-loading">
      <div class="spinner-ring"></div>
      <p class="role-loading__text">Loading…</p>
    </div>
  }

  @if (role) {
    <div class="role-selector">
      <div class="role-selector__header">
        <p class="role-selector__title">Choose your role</p>
        <p class="role-selector__subtitle">You have access to multiple roles. Select one to continue.</p>
      </div>

      <div class="role-cards">
        <a class="role-card" [routerLink]="['/secure/administrator']">
          <div class="role-card__icon role-card__icon--admin">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 4l5 2.18V11c0 3.5-2.33 6.79-5 7.93-2.67-1.14-5-4.43-5-7.93V7.18L12 5z"/>
            </svg>
          </div>
          <div class="role-card__body">
            <p class="role-card__title">Administrator</p>
            <p class="role-card__desc">Manage all applications and tokens</p>
          </div>
          <svg class="role-card__arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </a>

        <a class="role-card" [routerLink]="['/secure/developer']">
          <div class="role-card__icon role-card__icon--dev">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
            </svg>
          </div>
          <div class="role-card__body">
            <p class="role-card__title">Developer</p>
            <p class="role-card__desc">Manage your own applications</p>
          </div>
          <svg class="role-card__arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
          </svg>
        </a>
      </div>
    </div>
  }
</div>
